module.exports = __webpack_public_path__ + "static/media/acacia mall roof shot 04.4a319587.webp";